/**
 * MSW Overrides: List Bookings — No Breakdown scenario
 *
 * Forces listBookings to return bookings whose pricing.summary has no breakdown field,
 * so breakdown-absent rendering can be tested end-to-end in local development.
 *
 * Enable by setting ENABLE_MSW=true and MSW_OVERRIDE=true in your .env,
 * then restart the dev server.
 */

import { http, HttpResponse } from 'msw';
import { BFF_ENDPOINTS, createMockBookingsListResponse, toMSWPattern } from '@cvo/domain';
import type { PathParams } from 'msw';

export function createListBookingsNoBreakdownOverrides(baseUrl: string) {
  const sanitizedBaseUrl = baseUrl.replace(/\/$/, '');

  return [
    http.get(
      `${sanitizedBaseUrl}/${toMSWPattern(BFF_ENDPOINTS.BOOKING_LIST)}`,
      ({ request }: { request: Request; params: PathParams }) => {
        const url = new URL(request.url);
        const page = Number(url.searchParams.get('page')) || 1;

        const response = createMockBookingsListResponse({ page });

        const sanitized = {
          ...response,
          content: response.content.map((booking) => ({
            ...booking,
            pricing: {
              ...booking.pricing,
              summary: {
                ...booking.pricing.summary,
                breakdown: undefined,
              },
            },
          })),
        };

        return HttpResponse.json(sanitized);
      },
    ),
  ];
}
